import React, { useState, useEffect, useRef } from 'react';

const FlickerText = ({ value, flickerDuration = 600, className = '' }) => {
  const [flickerClass, setFlickerClass] = useState('');
  const prevValueRef = useRef(value);

  useEffect(() => {
    if (prevValueRef.current !== undefined && value !== prevValueRef.current) {
      const currentValueNum = parseFloat(String(value).replace(/[^0-9.-]+/g, ""));
      const prevValueNum = parseFloat(String(prevValueRef.current).replace(/[^0-9.-]+/g, ""));

      let direction = '';
      if (!isNaN(currentValueNum) && !isNaN(prevValueNum)) {
        direction = currentValueNum > prevValueNum ? 'price-up' : 'price-down';
      }
      
      setFlickerClass(direction);
      const timer = setTimeout(() => setFlickerClass(''), flickerDuration);
      prevValueRef.current = value;
      return () => clearTimeout(timer);
    } else {
      prevValueRef.current = value;
    }
  }, [value, flickerDuration]);

  return <span className={`${flickerClass} ${className}`.trim()}>{value}</span>;
};

export default FlickerText; 